import addItem from '../../state/tac/tacReducer/addItem';
import updateDependentItems from '../../state/tac/tacReducer/updateDependentItems';
import updateItem from '../../state/tac/tacReducer/updateItem';
import Item from '../Item';
import geometry from '../util/geometry';
import productService from '../../services/products';
import { ITEMS } from '../../constants';

export default class Upright extends Item {
  constructor(args) {
    super(args);
    this.sectionSprites = [];
  }

  static hitAreaPadding = 8;

  getHitArea() {
    const { scaledVertices } = this.data;

    const vertices = [
      [
        scaledVertices[0][0] - Upright.hitAreaPadding,
        scaledVertices[0][1] + Upright.hitAreaPadding,
      ], // front bottom left
      [
        scaledVertices[7][0] - Upright.hitAreaPadding,
        scaledVertices[7][1] - Upright.hitAreaPadding,
      ], // rear top left
      [
        scaledVertices[6][0] + Upright.hitAreaPadding,
        scaledVertices[6][1] - Upright.hitAreaPadding,
      ], // rear top right
      [
        scaledVertices[1][0] + Upright.hitAreaPadding,
        scaledVertices[1][1] + Upright.hitAreaPadding,
      ], // front bottom right
    ];

    const polygon = {
      regions: [vertices],
    };

    return { polygon };
  }

  scanPadding() {
    return {
      top: 0,
      bottom: 0,
      left: 800,
      right: 800,
      front: 0,
      back: 10,
    };
  }

  /**
   * Updates the dependents of a specific upright during a dragging event
   * @param {*} newItem
   * @returns {undefined}
   */
  updateDependentItemsDragging(newItem) {
    let updatedTac;

    if (newItem.itemid) {
      updatedTac = updateItem(this.app.tac, newItem);
    } else {
      // when dragging from swiper
      updatedTac = addItem(this.app.tac, newItem);

      // a new sprite will be created from the tmp item added to the fake tac,
      // so let's detach from our parent to avoid a conflict
      this.app.itemContainer.removeChild(this);
    }
    updatedTac = updateDependentItems(updatedTac, {
      triggerItem: newItem,
      flagTempItems: true,
    });

    this.app.itemContainer.update({
      room: this.app.room.model,
      options: this.app.itemContainerOptions,
      ratio: this.app.room.ratio,
      tac: updatedTac,
      updateOrigo: false,
    });
  }

  drawDropAreas(slots) {
    this.sectionSprites.forEach(section => section.drawDropAreas(slots));
  }

  eraseDropAreas() {
    this.sectionSprites.forEach(section => section.eraseDropAreas());
  }

  getChildDisplacementSprite(slot) {
    const sections = this.sectionSprites.map(sprite => sprite.item);
    const closest = geometry.closestCollidingRect(
      slot,
      sections.filter(section => slot.width === section.width)
    );

    return this.sectionSprites.find(
      section => section.item.itemid === closest.itemid
    );
  }

  getChildDisplacement(slot) {
    return this.getChildDisplacementSprite(slot).item;
  }

  addSprite(sprite, slot, tac) {
    this.getChildDisplacementSprite(slot).addSprite(sprite, slot, tac);
  }

  addSection(section) {
    this.removeSection(section);
    this.sectionSprites.push(section);
  }

  removeSection(section) {
    this.sectionSprites = this.sectionSprites.filter(
      sprite => sprite.item.itemid !== section.item.itemid
    );
  }

  cleanOutSectionSprites() {
    const currSecs = this.app.tac.items
      .filter(item => productService.isType(item, ITEMS.SECTION))
      .map(section => section.itemid);

    const sectionSpritesAfter = this.sectionSprites.filter(sprite =>
      currSecs.includes(sprite.item.itemid)
    );
    this.sectionSprites = sectionSpritesAfter;
  }
}
